import { motion } from "framer-motion";
import { ASSETS, CAPABILITIES } from "../../data";
import { Reveal, MaskLineInView } from "./Reveal";

const Counter = ({ v, u, d, i }) => (
  <motion.div
    data-testid={`capability-${i}`}
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-40px" }}
    transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: i * 0.08 }}
    className="p-8 md:p-10"
  >
    <div className="flex items-baseline gap-2">
      <span className="font-display text-4xl md:text-6xl font-semibold tracking-tighter text-[var(--ink)]">
        {v}
      </span>
      <span className="font-mono text-sm uppercase tracking-widest text-[var(--brand)]">{u}</span>
    </div>
    <p className="mt-3 text-[var(--muted)] leading-relaxed">{d}</p>
  </motion.div>
);

export const Infrastructure = () => (
  <section id="facility" data-testid="infrastructure-section" className="bg-white py-16 md:py-36">
    <div className="max-w-[1400px] mx-auto px-5 md:px-10">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <Reveal className="lg:col-span-6" y={50}>
          <div className="relative rounded-3xl overflow-hidden">
            <img
              src={ASSETS.factory}
              alt="Polycaps manufacturing facility"
              className="w-full h-[340px] md:h-[520px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[var(--ink)]/60 to-transparent" />
            <div className="absolute bottom-6 left-6 text-white">
              <span className="font-mono text-xs uppercase tracking-[0.25em]">Nagpur, India</span>
              <p className="font-display text-2xl font-medium tracking-tight mt-1">
                End-to-end in-house
              </p>
            </div>
          </div>
        </Reveal>

        <div className="lg:col-span-6">
          <span className="font-mono text-xs uppercase tracking-[0.25em] text-[var(--brand)]">
            Infrastructure & Capabilities
          </span>
          <h2 className="font-display font-semibold tracking-tighter leading-[0.98] mt-5 text-4xl md:text-5xl">
            <MaskLineInView>Where every cap</MaskLineInView>
            <MaskLineInView delay={0.08}>is proven.</MaskLineInView>
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-[var(--muted)]">
            A 25,000 sq. ft. facility with an in-house testing unit, SACMI (Italy) vision inspection
            for defect-free output, and a skilled workforce with deep domain knowledge — from design
            to final packaging.
          </p>

          <div className="mt-8 grid grid-cols-2 gap-px bg-slate-200 border border-slate-200 rounded-2xl overflow-hidden">
            {CAPABILITIES.map((c, i) => (
              <div key={c.k} className="bg-white">
                <Counter v={c.k} u={c.u} d={c.d} i={i} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);
